import { createStateSelectorHook } from 'src/lib/sweetState';

import { BrandVoicesStore } from './BrandVoicesStore';

const useBrandVoicesState = createStateSelectorHook(BrandVoicesStore, ['brandVoiceAssetsLoaded']);

export const useBrandVoiceAssetsLoaded = () => {
  const { brandVoiceAssetsLoaded } = useBrandVoicesState();
  return brandVoiceAssetsLoaded;
};
